export default __webpack_public_path__ + "static/proxima-nova-800-i-e398958b02e391336725bfc32bda59a5.woff";